module.exports = __webpack_public_path__ + "img/overtime-plans.0b372f3f.svg";